import type { LlmModel } from '@saaga/shared/interfaces/llm-model.interface'
import { type ComponentPropsWithoutRef, forwardRef, type ReactNode } from 'react'

import { ComboboxTrigger } from '@/components/atoms/combobox-trigger.atom'
import { cn } from '@/lib/utils'

export interface ModelSelectorTriggerProps
  extends Omit<ComponentPropsWithoutRef<'button'>, 'disabled'> {
  selectedModel: LlmModel | undefined
  placeholder: string
  isOpen: boolean
  isDisabled: boolean
}

export const ModelSelectorTrigger = forwardRef<HTMLButtonElement, ModelSelectorTriggerProps>(
  ({ selectedModel, placeholder, isOpen, isDisabled, className, ...rest }, ref): ReactNode => (
    <ComboboxTrigger
      ref={ref}
      isOpen={isOpen}
      isDisabled={isDisabled}
      className={cn('model-selector-searchable-trigger', className)}
      {...rest}
    >
      <span className={cn(!selectedModel && 'text-muted-foreground')}>
        {selectedModel?.name ?? placeholder}
      </span>
    </ComboboxTrigger>
  )
)

ModelSelectorTrigger.displayName = 'ModelSelectorTrigger'
